/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author        Afternet <info@afternet.gr>
 * @copyright   Afternet
 * @license        http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

export function floating_labels(){

    var _fields = $('.float-label input');

    _fields.each(function (i, el){
        build_float(el, el.value);
    })

    $(document).on('change, keyup', _fields, function (e){
        if(e.target.type !== "radio"){
            build_float(e.target, e.target.value);
        }
    });

    $(document).on('focusin', _fields, function (e){
        if(e.target.type !== "radio"){
            $(e.target).parents('.form-group').addClass('isFloatied');
        }
    });

    $(document).on('focusout', _fields, function (e){
        if( $(e.target).attr('data-action') === 'show-password'){
            var _value = $(e.target).parents('.form-group').find('input').val();
            if (typeof _value != undefined && _value == ''){
                $(e.target).parents('.form-group').removeClass('isFloatied');
            }
            return ;
        } //fix for show-password bug

        if(e.target.type !== "radio"){
            if( e.target.value == '' && !e.target.getAttribute('placeholder') ){
                $(e.target).parents('.form-group').removeClass('isFloatied');
            }
        }
    });

    function build_float(element, value){
        if ( value != '' || element.getAttribute('placeholder') ){
            $(element).parents('.form-group').addClass('isFloatied');
        }else{
            $(element).parents('.form-group').removeClass('isFloatied');
        }
    }

}
